<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading">
            {{ $t("loadingTxt") }}...
        </div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">
                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <h4 style="margin-right: 5px" class="float-start">
                                        {{ $t("rate_detail_storage") }}
                                    </h4>
                                    <button v-if="
                                        permision_role.method_create &&
                                        formsHeader.status == 'DISABLED'
                                    " class="btn btn-primary float-end btn-xs" style="margin-right: 5px" @click.prevent="createData()">
                                        <i class="link-icon mdi mdi-plus"></i>
                                        {{ $t("createNew") }}
                                    </button>

                                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="downloadData()">
                                        <i class="link-icon mdi mdi-download"></i>
                                        {{ $t("downloadData") }} .xlsx
                                    </button>

                                    <button v-if="permision_role.method_read" class="btn btn-warning float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="backForm()">
                                        <i class="link-icon mdi mdi-arrow-left"></i>
                                        {{ $t("backMess") }}
                                    </button>
                                </div>

                                <div class="card-body">
                                    <vue-good-table title="list-billing-cml-rate-detail-storage"
                                        ref="list-billing-cml-rate-detail-storage" mode="remote"
                                        @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
                                        :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{
                                            enabled: true,
                                            perPageDropdown: [10, 50, 100, 1000, 10000],
                                            dropdownAllowAll: false,
                                        }" :rows="rows" :columns="columns">
                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'actions'">
                                                <a href="#" v-if="permision_role.method_read" title="Detail"
                                                    @click.prevent="detailData(props.index, props.row)">
                                                    <i class="mdi mdi-eye" style="font-size: 16px"></i>
                                                </a>
                                                <a href="#" v-if="
                                                    permision_role.method_update &&
                                                    formsHeader.status == 'DISABLED'
                                                " title="Edit" @click.prevent="editData(props.index, props.row)">
                                                    <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                                                </a>

                                                <a href="#" v-if="
                                                    permision_role.method_delete &&
                                                    formsHeader.status == 'DISABLED'
                                                " title="Delete" @click.prevent="deleteData(props.index, props.row)">
                                                    <i class="mdi mdi-trash-can-outline" style="font-size: 16px"></i>
                                                </a>
                                            </span>
                                            <span v-else-if="props.column.field == 'rate'">
                                                {{ toCurrency(props.row.rate) }}
                                            </span>
                                            <span v-else-if="props.column.field == 'minQty'">
                                                {{ toNumber(props.row.minQty) }}
                                            </span>
                                            <span v-else-if="props.column.field == 'minAmount'">
                                                {{ toCurrency(props.row.minAmount) }}
                                            </span>
                                            <span v-else-if="props.column.field == 'calculationQty'">
                                                <span class="row">
                                                    <span class="col"> Rate </span>
                                                    <span class="col-6"> : {{ props.row.rate }} </span>
                                                </span>
                                                <span class="row">
                                                    <span class="col"> Min Qty </span>
                                                    <span class="col-6"> : {{ props.row.minQty }} </span>
                                                </span>
                                                <span class="row">
                                                    <span class="col"> Min Amount </span>
                                                    <span class="col-6">
                                                        : {{ props.row.minAmount }}
                                                    </span>
                                                </span>
                                                <span class="row">
                                                    <span class="col"> Pro Rate </span>
                                                    <span class="col-6"> : {{ props.row.proRate }} </span>
                                                </span>
                                                <span class="row">
                                                    <span class="col"> Summary Flag </span>
                                                    <span class="col-6">
                                                        : {{ props.row.summaryFlag }}
                                                    </span>
                                                </span>
                                            </span>

                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::modal-->
                <!--create rate-->
                <modal name="createBillingCmlRateDetailStorage" :draggable="false" :scrollable="true" :height="'auto'">
                    <div class="modal fade show" tabindex="-1" style="display: block" aria-modal="true" role="dialog">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                            <div class="modal-content">
                                <form class="forms-sample" @submit.prevent="submitData" method="POST">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">
                                            {{ this.$t("create_rate_detail_storage") }}
                                        </h5>
                                        <button type="button" class="btn-close" aria-label="btn-close"
                                            @click.prevent="removeModals()"></button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="row justify-content-md-center px-3">
                                            <div class="row mb-3">
                                                <div class="col-md-12">
                                                    <label for="idRateBase" class="form-label">{{
                                                        this.$t("rateBase_txt") }}:</label>
                                                    <v-select :options="fetchRate" v-model="bm_rate_base"
                                                        label="rateBaseDesc" return-object @search="asyncSearchRate"
                                                        @input="rateChange">
                                                        <template slot="option" slot-scope="option">
                                                            {{ option.idRateBase }} | {{ option.uom }} |
                                                            {{ option.rateBaseDesc }}
                                                        </template>
                                                    </v-select>
                                                    <div v-if="errors.idRateBase">
                                                        <div v-for="error in errors.idRateBase" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="chargeCategory" class="form-label">{{
                                                        this.$t("chargeCategory_txt")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="chargeCategory"
                                                        :placeholder="$t('chargeCategory_txt')"
                                                        v-model="forms.chargeCategory" disabled />
                                                    <div v-if="errors.chargeCategory">
                                                        <div v-for="error in errors.chargeCategory" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="chargeType" class="form-label">{{
                                                        this.$t("chargeType_txt") }}:</label>
                                                    <input type="text" class="form-control" id="chargeType"
                                                        :placeholder="$t('chargeType_txt')" v-model="forms.chargeType"
                                                        disabled />
                                                    <div v-if="errors.chargeType">
                                                        <div v-for="error in errors.chargeType" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="SAPMaterialCode" class="form-label">{{
                                                        this.$t("SAPMaterialCode")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="SAPMaterialCode"
                                                        :placeholder="$t('SAPMaterialCode')"
                                                        v-model="forms.SAPMaterialCode" disabled />
                                                    <div v-if="errors.SAPMaterialCode">
                                                        <div v-for="error in errors.SAPMaterialCode" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="SAPDivision" class="form-label">{{
                                                        this.$t("SAPDivision") }}:</label>
                                                    <input type="text" class="form-control" id="SAPDivision"
                                                        :placeholder="$t('SAPDivision')" v-model="forms.SAPDivision"
                                                        disabled />
                                                    <div v-if="errors.SAPDivision">
                                                        <div v-for="error in errors.SAPDivision" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="uom" class="form-label">{{ this.$t("uom") }}:</label>
                                                    <input type="text" class="form-control" id="uom"
                                                        :placeholder="$t('uom')" v-model="forms.uom" disabled />
                                                    <div v-if="errors.uom">
                                                        <div v-for="error in errors.uom" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="opportunity_id" class="form-label">{{
                                                        this.$t("opportunity_id")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="opportunity_id"
                                                        :placeholder="$t('opportunity_id')"
                                                        v-model="forms.opportunity_id" disabled />
                                                    <div v-if="errors.opportunity_id">
                                                        <div v-for="error in errors.opportunity_id" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="minQty" class="form-label">{{ this.$t("minQty")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="minQty"
                                                        :placeholder="$t('minQty')" v-model="forms.minQty"
                                                        @keypress="isNumber($event)" required />
                                                    <div v-if="errors.minQty">
                                                        <div v-for="error in errors.minQty" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="minAmount" class="form-label">{{ this.$t("minAmount")
                                                        }}:</label>
                                                    <money class="form-control" v-model="forms.minAmount"
                                                        v-bind="money"></money>
                                                    <div v-if="errors.minAmount">
                                                        <div v-for="error in errors.minAmount" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="summaryFlag" class="form-label">{{
                                                        this.$t("summaryFlag") }}:</label>
                                                    <v-select :options="fetchsummaryFlag" v-model="forms.summaryFlag"
                                                        return-object>
                                                    </v-select>
                                                    <div v-if="errors.summaryFlag">
                                                        <div v-for="error in errors.summaryFlag" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <!--<div class="col-md-4">
                                <label for="rate" class="form-label">{{this.$t("rate_txt")}}:</label>
                                <input type="text" class="form-control" id="rate" :placeholder="$t('rate_txt')" v-model="forms.rate" @keypress="isNumber($event)" required/>
                                <money class="form-control" v-model="forms.rate" v-bind="money"></money>
                                <div v-if="errors.rate">
                                <div
                                    v-for="error in errors.rate"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                                </div>

                            </div>-->
                                                <div class="col-md-4">
                                                    <label for="rate" class="form-label">{{ this.$t("rate") }}:</label>
                                                    <v-select :options="fetchOpportunityDetail"
                                                        v-model="opportunity_detail" label="price" return-object
                                                        @search="asyncSearchOpportunityDetail"
                                                        @input="inputOpportunityDetail">
                                                        <template slot="option" slot-scope="option">
                                                            {{ toCurrency(option.price) }}
                                                        </template>
                                                    </v-select>
                                                    <div v-if="errors.rate">
                                                        <div v-for="error in errors.rate" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="proRate" class="form-label">{{ this.$t("proRate")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="proRate"
                                                        :placeholder="$t('proRate')" v-model="forms.proRate"
                                                        @keypress="isNumber($event)" required />
                                                    <div v-if="errors.proRate">
                                                        <div v-for="error in errors.proRate" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="remark" class="form-label">{{ this.$t("remark")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="remark"
                                                        :placeholder="$t('remark')" v-model="forms.remark" />
                                                    <div v-if="errors.remark">
                                                        <div v-for="error in errors.remark" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                                            {{ this.$t("close_txt") }}
                                        </button>
                                        <button type="submit" class="btn btn-primary">
                                            {{ this.$t("save_change_txt") }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </modal>

                <!--edit rate-->
                <modal name="editBillingCmlRateDetailStorage" :draggable="false" :scrollable="true" :height="'auto'">
                    <div class="modal fade show" tabindex="-1" style="display: block" aria-modal="true" role="dialog">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                            <div class="modal-content">
                                <form class="forms-sample" @submit.prevent="submitEditData" method="POST">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">
                                            {{ this.$t("update_rate_detail_storage") }}
                                        </h5>
                                        <button type="button" class="btn-close" aria-label="btn-close"
                                            @click.prevent="removeModals()"></button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="row justify-content-md-center px-3">
                                            <div class="row mb-3">
                                                <div class="col-md-12">
                                                    <label for="idRateBase" class="form-label">{{
                                                        this.$t("rateBase_txt") }}:</label>
                                                    <v-select :options="fetchRate" v-model="forms.rateBaseDesc"
                                                        label="rateBaseDesc" return-object @search="asyncSearchRate"
                                                        @input="rateChange">
                                                        <template slot="option" slot-scope="option">
                                                            {{ option.idRateBase }} | {{ option.uom }} |
                                                            {{ option.rateBaseDesc }}
                                                        </template>
                                                    </v-select>
                                                    <div v-if="errors.idRateBase">
                                                        <div v-for="error in errors.idRateBase" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="chargeCategory" class="form-label">{{
                                                        this.$t("chargeCategory_txt")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="chargeCategory"
                                                        :placeholder="$t('chargeCategory_txt')"
                                                        v-model="forms.chargeCategory" disabled />
                                                    <div v-if="errors.chargeCategory">
                                                        <div v-for="error in errors.chargeCategory" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="chargeType" class="form-label">{{
                                                        this.$t("chargeType_txt") }}:</label>
                                                    <input type="text" class="form-control" id="chargeType"
                                                        :placeholder="$t('chargeType_txt')" v-model="forms.chargeType"
                                                        disabled />
                                                    <div v-if="errors.chargeType">
                                                        <div v-for="error in errors.chargeType" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="SAPMaterialCode" class="form-label">{{
                                                        this.$t("SAPMaterialCode")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="SAPMaterialCode"
                                                        :placeholder="$t('SAPMaterialCode')"
                                                        v-model="forms.SAPMaterialCode" disabled />
                                                    <div v-if="errors.SAPMaterialCode">
                                                        <div v-for="error in errors.SAPMaterialCode" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="SAPDivision" class="form-label">{{
                                                        this.$t("SAPDivision") }}:</label>
                                                    <input type="text" class="form-control" id="SAPDivision"
                                                        :placeholder="$t('SAPDivision')" v-model="forms.SAPDivision"
                                                        disabled />
                                                    <div v-if="errors.SAPDivision">
                                                        <div v-for="error in errors.SAPDivision" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="uom" class="form-label">{{ this.$t("uom") }}:</label>
                                                    <input type="text" class="form-control" id="uom"
                                                        :placeholder="$t('uom')" v-model="forms.uom" disabled />
                                                    <div v-if="errors.uom">
                                                        <div v-for="error in errors.uom" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="opportunity_id" class="form-label">{{
                                                        this.$t("opportunity_id")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="opportunity_id"
                                                        :placeholder="$t('opportunity_id')"
                                                        v-model="forms.opportunity_id" disabled />
                                                    <div v-if="errors.opportunity_id">
                                                        <div v-for="error in errors.opportunity_id" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-4">
                                                    <label for="minQty" class="form-label">{{ this.$t("minQty")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="minQty"
                                                        :placeholder="$t('minQty')" v-model="forms.minQty"
                                                        @keypress="isNumber($event)" required />
                                                    <div v-if="errors.minQty">
                                                        <div v-for="error in errors.minQty" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="minAmount" class="form-label">{{ this.$t("minAmount")
                                                        }}:</label>
                                                    <money class="form-control" v-model="forms.minAmount"
                                                        v-bind="money"></money>
                                                    <div v-if="errors.minAmount">
                                                        <div v-for="error in errors.minAmount" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="summaryFlag" class="form-label">{{
                                                        this.$t("summaryFlag") }}:</label>
                                                    <v-select :options="fetchsummaryFlag" v-model="forms.summaryFlag"
                                                        return-object></v-select>
                                                    <div v-if="errors.summaryFlag">
                                                        <div v-for="error in errors.summaryFlag" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <!--<div class="col-md-4">
                                <label for="rate" class="form-label">{{this.$t("rate_txt")}}:</label>
                                <input type="text" class="form-control" id="rate" :placeholder="$t('rate_txt')" v-model="forms.rate" @keypress="isNumber($event)" required/>
                                <money class="form-control" v-model="forms.rate" v-bind="money"></money>
                                <div v-if="errors.rate">
                                <div
                                    v-for="error in errors.rate"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                </div>
                                </div>
                            </div>-->
                                                <div class="col-md-4">
                                                    <label for="rate" class="form-label">{{ this.$t("rate") }}:</label>
                                                    <v-select :options="fetchOpportunityDetail" v-model="forms.rate"
                                                        label="price" return-object
                                                        @search="asyncSearchOpportunityDetail"
                                                        @input="inputOpportunityDetail">
                                                        <template slot="option" slot-scope="option">
                                                            {{ toCurrency(option.price) }}
                                                        </template>
                                                    </v-select>
                                                    <div v-if="errors.rate">
                                                        <div v-for="error in errors.rate" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="proRate" class="form-label">{{ this.$t("proRate")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="proRate"
                                                        :placeholder="$t('proRate')" v-model="forms.proRate"
                                                        @keypress="isNumber($event)" required />
                                                    <div v-if="errors.proRate">
                                                        <div v-for="error in errors.proRate" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label for="remark" class="form-label">{{ this.$t("remark")
                                                        }}:</label>
                                                    <input type="text" class="form-control" id="remark"
                                                        :placeholder="$t('remark')" v-model="forms.remark" />
                                                    <div v-if="errors.remark">
                                                        <div v-for="error in errors.remark" :key="error"
                                                            class="alert alert-primary" role="alert">
                                                            <i data-feather="alert-circle"></i>
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                                            {{ this.$t("close_txt") }}
                                        </button>
                                        <button type="submit" class="btn btn-primary">
                                            {{ this.$t("save_change_txt") }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </modal>
                <!--end::modal-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
    name: "CmlRateDetailStorageIndex",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
    },
    computed: {
        solicitorsFeesDisplay: {
            get: function () {
                return this.forms.rate.toFixed(5);
            },
            set: function (newValue) {
                this.forms.rate = newValue;
            },
        },
    },
    data() {
        return {
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "",
                precision: 2,
                masked: false,
            },
            maxToasts: 100,
            fetchRate: [],
            fetchOpportunityDetail: [],
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            idRateDetailStorages: [],
            fetchsummaryFlag: ["N", "Y"],
            detailDivisi: [],
            bm_rate_header_cml: null,
            bm_rate_base: null,
            opportunity_detail: null,
            forms: {
                idRateBase: "",
                uom: "",
                opportunity_id: "",
                idRateDetailStorage: "",
                idRateHeader: "",
                chargeCategory: "",
                adddate: "",
                addwho: "",
                editdate: "",
                editwho: "",
                SAPMaterialCode: "",
                chargeType: "",
                rate: "",
                SAPDivision: "",
                remark: "",
                minQty: 0,
                minAmount: 0,
                summaryFlag: "N",
                proRate: 0,
            },
            formsHeader: {
                opportunity_id: "",
                idRateHeader: "",
                organizationId: "",
                customerId: "",
                customerSAPCode: "",
                tariffId: "",
                warehouseId: "",
                rateName: "",
                effectiveDate: "",
                rateDesc: "",
                firstBilingDate: "",
                effectiveFromDate: "",
                effectiveToDate: "",
                status: "",
                addwho: "",
                editwho: "",
                adddate: "",
                editdate: "",
            },
            totalRecords: 0,
            effectiveToDate: "",
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: "text-center",
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                        enabled: false,
                    },
                },
                {
                    label: this.$t("chargeCategory_txt"),
                    field: "chargeCategory",
                    width: "150px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("chargeCategory_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("chargeType_txt"),
                    field: "chargeType",
                    width: "150px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("chargeType_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("rateBaseDesc_txt"),
                    field: "rateBaseDesc",
                    width: "250px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("rateBaseDesc_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("calculationQty"),
                    field: "calculationQty",
                    width: "300px",
                    thClass: "text-center",
                },
                {
                    label: this.$t("uom"),
                    field: "uom",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("uom"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("remark"),
                    field: "remark",
                    width: "200px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("remark"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("SAPMaterialCode"),
                    field: "SAPMaterialCode",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("SAPMaterialCode"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("SAPDivision"),
                    field: "SAPDivision",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("SAPDivision"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("rate_txt"),
                    field: "rate",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("rate_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("minQty"),
                    field: "minQty",
                    width: "100px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("minQty"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("minAmount"),
                    field: "minAmount",
                    width: "100px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("minAmount"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("proRate"),
                    field: "proRate",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("proRate"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("summaryFlag"),
                    field: "summaryFlag",
                    width: "100px",
                    thClass: "text-center",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("summaryFlag"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
            ],
            rows: [],
            rowsSelection: [],
        };
    },
    watch: {},
    methods: {
        inputOpportunityDetail(ev) {
            this.forms.rate = ev.price;
        },

        getOpportunityDetail() {
            const baseURI =
                this.$settings.endPointBilling +
                `dashboard/cml-billing/rate/header/get-data-opportunity-detail?opportunity_id=${this.formsHeader.opportunity_id}&product_code=${this.forms.SAPMaterialCode}&uom=${this.forms.uom}`;

            return this.$http
                .get(baseURI, { timeout: 60000 })
                .then((response) => {
                    this.fetchOpportunityDetail = response.data.datas;
                })
                .catch((error) => {
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                });
        },

        asyncSearchOpportunityDetail() {
            const baseURI =
                this.$settings.endPointBilling +
                `dashboard/cml-billing/rate/header/get-data-opportunity-detail?opportunity_id=${this.formsHeader.opportunity_id}&product_code=${this.forms.SAPMaterialCode}&uom=${this.forms.uom}`;

            return this.$http
                .get(baseURI, { timeout: 60000 })
                .then((response) => {
                    this.fetchOpportunityDetail = response.data.datas;
                })
                .catch((error) => {
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                });
        },

        toCurrency(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "IDR",
            });
            return formatter.format(value);
        },

        toNumber(value) {
            if (typeof value !== "number") {
                return value;
            }

            return Number(value).toLocaleString();
        },

        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        submitEditData() {
            this.isLoading = true;
            var params = this.$onBehind(this.$route.params.id);
            var idRateHeader = params[0];
            this.forms.idRateHeader = idRateHeader;
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-detail-storage-update/" +
                this.forms.idRateDetailStorage;
            this.$http
                .patch(baseURI, this.forms, { timeout: 60000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        this.removeModals();
                        this.loadItems();
                        this.success("Successfully");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    this.isLoading = false;

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }

                    //this.resetForm();
                });
        },

        submitData() {
            this.isLoading = true;
            var params = this.$onBehind(this.$route.params.id);
            var idRateHeader = params[0];
            this.forms.idRateHeader = idRateHeader;
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-detail-storage-create";
            this.$http
                .post(baseURI, this.forms, { timeout: 60000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        this.removeModals();
                        this.loadItems();
                        this.success("Successfully");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    this.isLoading = false;

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }

                    //this.resetForm();
                });
        },

        rateChange(ev) {
            this.forms.idRateBase = ev.idRateBase;
            this.forms.rateBaseDesc = ev.rateBaseDesc;
            this.forms.chargeCategory = ev.chargeCategory;
            this.forms.chargeType = ev.chargeType;
            this.forms.SAPMaterialCode = ev.SAPMaterialCode;
            this.forms.SAPDivision = ev.SAPDivision;
            this.forms.uom = ev.uom;
            this.opportunity_detail = "";
            this.forms.rate = "";
            this.getOpportunityDetail();
        },

        getRateBase() {
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/ratebase/get-data&status=ACTIVE";

            return this.$http
                .get(baseURI + `?limit=1000`, { timeout: 60000 })
                .then((response) => {
                    this.fetchRate = response.data.datas.data;
                })
                .catch((error) => {
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                });
        },

        asyncSearchRate(ev) {
            const baseURI =
                this.$settings.endPointBilling + "dashboard/cml-billing/ratebase";
            return this.$http
                .get(baseURI + `?rateBaseDesc=${ev}&limit=100&status=ACTIVE`, { timeout: 60000 })
                .then((response) => {
                    this.fetchRate = response.data.datas.data;
                });
        },

        backForm() {
            var params = this.$route.params.id;

            window.location.href = "/billing-cml/rates/header/detail/" + params;
        },

        removeModals() {
            this.$modal.hide("createBillingCmlRateDetailStorage");
            this.$modal.hide("editBillingCmlRateDetailStorage");
            this.forms.idRateDetailStorage = "";
            this.forms.idRateHeader = "";
            this.forms.chargeCategory = "";
            this.forms.idRateBase = "";
            this.forms.rateBaseDesc = "";
            this.forms.uom = "";
            this.forms.summaryFlag = "N";
            this.forms.chargeType = "";
            this.forms.SAPMaterialCode = "";
            this.forms.SAPDivision = "";
            this.forms.rate = 0;
            this.forms.proRate = 0;
            this.forms.minQty = 0;
            this.forms.minAmount = 0;
            this.forms.remark = "";
            this.forms.adddate = "";
            this.forms.addwho = "";
            this.forms.editdate = "";
            this.forms.editwho = "";
            this.errors = [];
            this.bm_rate_header_cml = null;
            this.bm_rate_base = null;
            this.opportunity_detail = null;
        },

        selectionChanged(ev) {
            this.rowsSelection = [];
            this.idRateDetailStorages = [];
            this.rowsSelection = ev.selectedRows;

            this.rowsSelection.forEach((item) => {
                this.idRateDetailStorages.push(item.idRateDetailStorage);
            });
        },

        downloadData() {
            var params = this.$onBehind(this.$route.params.id);
            var idRateHeader = params[0];
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-detail-storage/" +
                idRateHeader;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&chargeType=${this.serverParams.columnFilters.chargeType}&chargeCategory=${this.serverParams.columnFilters.chargeCategory}&SAPMaterialCode=${this.serverParams.columnFilters.SAPMaterialCode}&SAPDivision=${this.serverParams.columnFilters.SAPDivision}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&summaryFlag=${this.serverParams.columnFilters.summaryFlag}&remark=${this.serverParams.columnFilters.remark}&download=download`,
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
        },

        createData() {
            this.removeModals();
            this.$modal.show("createBillingCmlRateDetailStorage");
        },

        editData(index, row) {
            this.forms.idRateDetailStorage = row.idRateDetailStorage;
            this.forms.idRateHeader = row.idRateHeader;
            this.forms.chargeCategory = row.chargeCategory;
            this.forms.chargeType = row.chargeType;
            this.forms.SAPMaterialCode = row.SAPMaterialCode;
            this.forms.SAPDivision = row.SAPDivision;
            this.forms.idRateBase = row.idRateBase;
            this.forms.rateBaseDesc = row.rateBaseDesc;
            this.forms.uom = row.uom;
            this.forms.summaryFlag = row.summaryFlag;
            this.forms.rate = row.rate;
            this.forms.remark = row.remark;
            this.forms.adddate = row.adddate;
            this.forms.addwho = row.addwho;
            this.forms.editdate = row.editdate;
            this.forms.editwho = row.editwho;
            this.forms.minQty = row.minQty;
            this.forms.proRate = row.proRate;
            this.forms.minAmount = row.minAmount;
            this.fetchRate = [];
            this.fetchOpportunityDetail = [];
            this.bm_rate_base = {
                rateBaseName: row.chargeType,
                chargeCategory: row.chargeCategory,
                chargeType: row.chargeType,
                SAPMaterialCode: row.SAPMaterialCode,
                SAPDivision: row.SAPDivision,
            };
            this.$modal.show("editBillingCmlRateDetailStorage");
        },

        detailData(index, row) {
            var paramidRateDetailStorage = this.$onRandom(row.idRateDetailStorage);
            window.location.href =
                "/billing-cml/rates/detail-sub-storage/" + paramidRateDetailStorage;
        },

        deleteData(index, row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        status: status,
                    };
                    const baseURI =
                        this.$settings.endPointBilling +
                        "dashboard/cml-billing/rate/bm-rate-detail-storage-delete/" +
                        row.idRateDetailStorage;
                    this.$http
                        .delete(baseURI, formData, { timeout: 60000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {
                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                        this.$router.push("/server-error");
                                    } else {
                                        this.$router.push("/page-not-found");
                                    }
                                }
                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },

        logout() {
            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                console.log(response);
            });

            this.$logoutUser();
            window.location.href = "/";
        },

        // load items is what brings back the rows from server
        loadItems() {
            var params = this.$onBehind(this.$route.params.id);
            var idRateHeader = params[0];

            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-detail-storage/" +
                idRateHeader;
            this.isLoading = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&chargeType=${this.serverParams.columnFilters.chargeType}&chargeCategory=${this.serverParams.columnFilters.chargeCategory}&SAPMaterialCode=${this.serverParams.columnFilters.SAPMaterialCode}&SAPDivision=${this.serverParams.columnFilters.SAPDivision}&rateBaseDesc=${this.serverParams.columnFilters.rateBaseDesc}&summaryFlag=${this.serverParams.columnFilters.summaryFlag}&remark=${this.serverParams.columnFilters.remark}`,
                    { timeout: 60000 }
                )
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                })
                .catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }
                });
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "RateHeaderCmlController") {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
            this.getRateBase();
        },

        loadData(id) {
            this.isLoading = true;

            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/header/detail/" +
                id;
            return this.$http
                .get(baseURI, { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.formsHeader = response.data.datas;
                    this.forms.opportunity_id = response.data.datas.opportunity_id;
                    this.formsHeader.effectiveDate =
                        response.data.datas.effectiveFromDate +
                        "~" +
                        response.data.datas.effectiveToDate;
                })
                .catch((error) => {
                    this.isLoading = false;

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }
                });
        },
    },
    events: {},
    created: function () { },
    mounted() {
        var params = this.$onBehind(this.$route.params.id);
        this.loadData(params[0]);
        this.fetchIt();
        this.loading();
    },
};
</script>
<style scoped>
.blur-content {
    filter: blur(5px);
}
</style>
